import { render, staticRenderFns } from "./NewPaymentsCreateAdmin.vue?vue&type=template&id=4955c90e&scoped=true"
import script from "./NewPaymentsCreateAdmin.vue?vue&type=script&lang=js"
export * from "./NewPaymentsCreateAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955c90e",
  null
  
)

export default component.exports